module.exports = __webpack_public_path__ + "static/media/Wordicon.baf3828e.svg";